// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const necrozma_ultra: PokeData = {
  "id": 10157,
  "name": "necrozma-ultra",
  "height": 75,
  "weight": 2300,
  "base_experience": 339,
  "types": [
    PokeType.PSYCHIC,
    PokeType.DRAGON
  ],
  "api_moves": [
    "confusion",
    "slash",
    "metal-claw",
    "morning-sun",
    "moonlight",
    "iron-defense",
    "rock-blast",
    "gravity",
    "wring-out",
    "night-slash",
    "power-gem",
    "psycho-cut",
    "mirror-shot",
    "stealth-rock",
    "charge-beam",
    "autotomize",
    "stored-power",
    "prismatic-laser",
    "photon-geyser"
  ],
  "moves": [
    "metal-claw",
    "morning-sun",
    "moonlight",
    "rock-blast",
    "night-slash",
    "stealth-rock",
    "psy-pulse",
    "psy-ball",
    "dragon-dance",
    "psychic-terrain",
    "inner-spirit",
    "outrage",
    "dragon-pulse"
  ],
  "evolution_chain": {
    "id": 421,
    "item": null,
    "species": [
      {
        "name": "necrozma",
        "order": 800,
        "types": [
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 99,
    "speed": 131,
    "ability_power": 170
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
